module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "todo",
    class: {
      completed: _vm.todo.completed, editing: _vm.editedTodo
    }
  }, [_c('div', {
    staticClass: "view"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.completed),
      expression: "todo.completed"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.todo.completed) ? _vm._i(_vm.todo.completed, null) > -1 : (_vm.todo.completed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.todo.completed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.todo.completed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.todo.completed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.todo, "completed", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    on: {
      "dblclick": function($event) {
        _vm.editTodo()
      }
    }
  }, [_vm._v(_vm._s(_vm.todo.title))]), _vm._v(" "), _c('button', {
    staticClass: "destroy",
    on: {
      "click": function($event) {
        _vm.removeTodo()
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.title),
      expression: "todo.title"
    }, {
      name: "todo-focus",
      rawName: "v-todo-focus",
      value: (_vm.editedTodo),
      expression: "editedTodo"
    }],
    staticClass: "edit",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.todo.title)
    },
    on: {
      "blur": function($event) {
        _vm.doneEdit()
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.doneEdit()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.cancelEdit()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.todo, "title", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8eff881a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoListItem.vue
// module id = 32
// module chunks = 1